import ReportScore from "./ReportScore";
export default ReportScore;